import IntegrationType from "@/models/Integrations/IntegrationType";

export default (value: IntegrationType) => {
    switch (value) {
        case IntegrationType.TransactionalEmail:
            return "Transactional Email";
        case IntegrationType.Invoicing:
            return "Invoicing";
        case IntegrationType.SSOMailboxSync:
            return "SSO & Mailbox Sync";
        case IntegrationType.Payroll:
            return "Payroll";
        default:
            return "Unknown";
    }
} 